require('smoothscroll-polyfill').polyfill();

// Use smooth scrolling for same-page anchor links

const commentsBoxes = document.querySelectorAll('.comments-box');
[...document.querySelectorAll('a:not(.skip-link):not(.open-chat)')].forEach((elem) => {
  const href = elem.getAttribute('href');
  elem.addEventListener('click', (e) => {
    // Ignore links that aren't scroll anchors
    if (!/^(\/)?#/.test(href)) return false;

    // Ignore links inside comment boxes
    if ([...commentsBoxes].some(commentBox => commentBox.contains(elem))) {
      return false;
    }

    // Otherwise stop the event and smoothscroll instead
    e.preventDefault();
    let scrollDestination = 0;
    if (!/^(\/)?#$/.test(href)) {
      // We're scrolling to an element, not to the top of the page
      const destination = document.querySelector(href);
      if (destination) {
        // Use the distance from the element to the top of the viewport, plus the amount we've scrolled
        const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        scrollDestination = destination.getBoundingClientRect().top + scrollTop;
      }
    }
    return window.scrollTo({
      top: scrollDestination,
      left: 0,
      behavior: 'smooth',
    });
  });
});
